import React from "react";

import MstrAppHost from "../mstrApp/MstrAppHost";

const Mstr = () => {
  return (
    <div
      style={{
        height: "100%",
        minHeight: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      <MstrAppHost />
    </div>
  );
};

export default Mstr;
